<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-card elevation="0" min-width="100%">
      <data-table
        v-model="selectedItems"
        :title="title"
        :data-path="fullPath"
        :headers="headers"
        :class="{ 'table-cursor': hasRowClickListener }"
        :extraSortBy="extraSortBy"
        :extraSortByDirection="extraSortByDirection"
        :search="search"
        @editItem="editItem"
        @click:row="$emit('click:row', $event)"
        @update:totalItems="totalItems = $event"
        :showSelect="showSelect"
        :defaultSortBy="defaultSortBy"
        :defaultSortByDirection="defaultSortByDirection"
      >
        <template v-slot:actions v-if="hasNewItemFunctionality">
          <v-btn
            color="primary"
            class="button"
            outlined
            tile
            @click="showNewTableItemPopup"
            >{{ newActionTitle ? newActionTitle : 'New' }}</v-btn
          >
        </template>
        <template v-slot:itemName="{ item }">
          {{ item.name }}
          <v-icon small color="primary" v-if="item.primary" class="mb-1"
            >mdi-star</v-icon
          >
        </template>
        <template
          v-slot:item="{ item, index }"
          v-if="!!this.$scopedSlots['item']"
          ><slot
            name="item"
            :item="item"
            :editItem="editItem"
            :index="index"
          ></slot
        ></template>
      </data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="editingPopupVisible" persistent max-width="600px">
        <slot
          name="newItemPopup"
          v-bind:close="closeEditItemPopup"
          v-bind:item="editingItem"
          v-bind:totalItems="totalItems"
          v-bind:formKey="editingPopupKey"
        ></slot>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EditableDataTable',
  components: {
    DataTable,
  },
  props: {
    value: {
      type: Array,
      defualt: () => [],
    },
    title: String,
    headers: {
      type: Array,
      required: true,
    },
    dataBasePath: {
      type: String,
    },
    collectionName: {
      type: String,
      required: true,
    },
    newActionTitle: String,
    defaultSortBy: {
      type: String,
    },
    defaultSortByDirection: {
      type: String,
      default: 'asc',
    },
    extraSortBy: {
      type: String,
    },
    extraSortByDirection: {
      type: String,
      default: 'asc',
    },
    search: {
      type: Array,
      validator: (prop) => prop.every((e) => e.length === 3),
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editingItem: null,
      totalItems: 0,
      selectedItems: this.value,
      editingPopupKey: new Date().toString(),
    }
  },
  watch: {
    selectedItems: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true,
    },
    value: {
      handler(newVal) {
        this.selectedItems = newVal
      },
      deep: true,
    },
    editingPopupVisible() {
      this.editingPopupKey = new Date().toString()
    },
  },
  computed: {
    ...mapGetters(['companyId', 'newTableItemPopupVisible']),
    editingPopupVisible() {
      return this.newTableItemPopupVisible
    },
    /**
     Base path for collection.
     Can be overriden with `dataBasePath` property (in case you need a subcollection)
     */
    _basePath() {
      return this.dataBasePath ?? `companies/${this.companyId}`
    },
    /**
      Use for full path to the firestore collection
     */
    fullPath() {
      return this._basePath + '/' + this.collectionName
    },

    hasNewItemFunctionality() {
      return !!this.$scopedSlots['newItemPopup'] && this.newActionTitle
    },
    hasRowClickListener() {
      return this.$listeners && this.$listeners['click:row']
    },
  },
  methods: {
    ...mapActions(['hideNewTableItemPopup', 'showNewTableItemPopup']),
    closeEditItemPopup() {
      this.editingItem = null
      this.hideNewTableItemPopup()
    },
    editItem(item) {
      this.editingItem = item
      this.showNewTableItemPopup()
    },
  },
  mounted() {
    this.$on('close', this.closeEditItemPopup())
  },
}
</script>

<style lang="sass">
.table-cursor tbody tr:hover
  cursor: pointer
</style>
